import "./SlideableSidePanel.scss";

import React from "react";
import {IconSize} from "../../services/IconConstants";
import CrossIcon from "../../icons/CrossIcon";

interface Props {
    open: boolean;
    handleClose: () => void;
    children: React.ReactNode;
    width?: number
}

const SlideableSidePanel = ({ open, handleClose, children, width = 70 }: Props) => {
    
    return (
        <>
            {open && <div className={"slideable-side-panel-overlay"} onClick={handleClose} />}
            <div className={`slideable-side-panel-container ${open ? "slideable-side-panel-open" : ""}`}
                style={{
                    width: `${width}%`,
                    right: open ? '0' : `-${width}%`,
                }}
            >
                <div>
                    <div onClick={handleClose} className={"slideable-side-panel-close-container"}>
                        <CrossIcon size={IconSize.md} className={"slideable-side-panel-close-icon"}/>
                        <span>Close</span>
                    </div>
                </div>

                <div className={"slideable-side-panel-content-container"}>
                    {children}
                </div>
            </div>
        </>
    );
};

export default SlideableSidePanel;